import './4starrestaurantgroup1/style';
import FormStructure from './4starrestaurantgroup1/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/includes.js